import MenuItem from '@mui/material/MenuItem'
import { CommunityResource } from '@rallycry/api-suite-typescript/dist/models'
import { Select } from 'formik-mui'
import { useFormikContext } from 'formik'
import { useEffect } from 'react'
import { RcTrans } from '@/components/atoms/RcTrans'
import { CommunityAvatar } from '@/components/organisms/avatar/CommunityAvatar'
import { LabeledField } from '@/components/organisms/form/LabeledField'
import { expander } from '@/core/expand'
import { useUserTopCommunities } from '@/entity/user/useUserTopCommunities'

export const FormikUserCommunityPicker = ({ userId }: { userId?: number }) => {
  const { values, validateForm } = useFormikContext<any>()
  const { topCommunities } = useUserTopCommunities({
    idOrKey: userId,
    suspense: false
  })

  useEffect(() => {
    values?.representing && validateForm()
  }, [values?.representing, validateForm])

  return (
    <LabeledField
      disabled={!userId}
      component={Select}
      displayEmpty
      label={<RcTrans i18nKey='competition:team.community-label' />}
      name='representing'
      variant='outlined'
      fullWidth
    >
      <MenuItem value={0}>
        <RcTrans i18nKey='shared.none-selected' />
      </MenuItem>
      {topCommunities.map(it => {
        const c = expander<CommunityResource>(it, 'community')!
        return (
          <MenuItem key={c.id} value={c.id}>
            <CommunityAvatar
              community={c}
              skipTags
              onClick={() => {
                /*noop*/
              }}
            />
          </MenuItem>
        )
      })}
    </LabeledField>
  )
}
